// extracted by mini-css-extract-plugin
export default {"value":"SecondOrderResults_value__4Tk4f","wrapper":"SecondOrderResults_wrapper__muBFk"};